<style lang="postcss">
  .loader,
  .loader:before,
  .loader:after {
    border-radius: 50%;
    width: 1em;
    height: 1em;
    animation-fill-mode: both;
    animation: load 1.8s infinite ease-in-out;
  }

  .loader {
    position: relative;
    transform: translateZ(0);
    margin: 1em 2rem 0;
    color: var(--ubilabs-blue-light-3);
    animation-delay: 0.66s;
  }

  .loader:before,
  .loader:after {
    content: '';
    position: absolute;
    top: 0;
  }

  .loader:before {
    left: -1.5em;
    animation-delay: 0.5s;
  }

  .loader:after {
    left: 1.5em;
    animation-delay: 0.82s;
  }

  @keyframes load {
    0%,
    80%,
    100% {
      box-shadow: 0 -1em 0 -1em;
    }
    30% {
      box-shadow: 0 -1em 0 0;
    }
  }
</style>

<div class="loader {$$props.class}" />
